import { render, staticRenderFns } from "./addAllocateDiglog.vue?vue&type=template&id=fa359dce&scoped=true"
import script from "./addAllocateDiglog.vue?vue&type=script&lang=js"
export * from "./addAllocateDiglog.vue?vue&type=script&lang=js"
import style0 from "./addAllocateDiglog.vue?vue&type=style&index=0&id=fa359dce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa359dce",
  null
  
)

export default component.exports